<template>
  <v-dialog v-model="visible" max-width="638" persistent>
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.deleteUserDialog.deleteUser`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          :disabled="isLoading"
          @click.native="close(null)"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4 pt-0 pb-5">
        <p>{{ $t(`${namespace}.deleteUserDialog.confirm`) }}</p>
        <p class="mb-0">{{ $t(`${namespace}.deleteUserDialog.message`) }}</p>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer/>

        <a
          v-if="!isLoading"
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="close(null)"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          :loading="isLoading"
          :disabled="isLoading"
          color="accent"
          depressed
          round
          @click.native="deleteUser"
        >
          {{ $t(`${namespace}.deleteUserDialog.deleteUser`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { isArray } from 'utils/functions'

export default {
  name: 'SingleDeleteDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object
    }
  },
  data () {
    return {
      namespace: 'Views.UsersPage',
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error',
      showAlert: 'snackbar/show'
    }),

    isValidArray (val) {
      return isArray(val)
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    async deleteUser () {
      this.isLoading = true

      try {
        const userId = this.item.corporateId
        const { data: res } = await this.$apiService.users.delete(userId)
        let closeModal = false

        if (res && !res.valid) {
          const message = this.isValidArray(res.reasons) ? res.reasons[0] : this.$t('Common.genericErrorMsg')
          this.errorAlert(message)
        } else if (!res.content) {
          this.errorAlert(this.$t(`${this.namespace}.notFound`))
        } else {
          closeModal = true
          this.successAlert(this.$t(`${this.namespace}.deleteUserDialog.successMessage`))
        }

        this.close(closeModal)
      } catch (err) {
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.deleteUserDialog.errorMessage`)
        })
        console.log('ERROR:', err)
      }

      this.isLoading = false
    }
  }
}
</script>
